import React, { Fragment } from 'react'
import DefaultLayout from '../default'
import styled from 'styled-components'
import classNames from 'classnames'
import { Icon } from '../../../components'
import { ANSWERED } from '../../../config'

const Child = styled.div`
    background-color: ${props => props.theme.colorTable.backLight};
`

const ChildInline = ({
  id,
  link,
  context,
  index,
  status,
  activate,
  topRecordId,
  inLinkedObj,
  change,
}) => {
  const varDef = context.getThisVarDef()
  const definition = context.typeDef && context.typeDef.layouts &&
    context.typeDef.layouts[0]

  let isMargin = false
  if (definition && varDef.isList) {
    context.useTableStyle = definition.rows.length === 1 && index > 0
    isMargin = definition.rows.length === 1
  }

  return (
    <Fragment>
      <Child key={id}
             className={classNames(
               'px-2 pt-2 rounded animate__animated animate__fadeIn',
               { 'w-100': varDef.isList },
               isMargin
                 ? { 'mb-0': varDef.isList }
                 : { 'mb-3': varDef.isList })}
             style={{ marginBottom: '1px !important' }}
      >

        <DefaultLayout context={context}
                       topRecordId={topRecordId}
                       activate={activate}
                       inLinkedObj={inLinkedObj || Boolean(link)}
                       change={change}/>

      </Child>
      {varDef.isList && (<Icon type={mapIcon(status)}
                               className={classNames(
                                 ' align-middle ans-status-icon d-block',
                                 mapIconStyle(status))}
                               style={{
                                 zIndex: 1,
                                 position: 'absolute',
                                 left: 'calc(100% - 3.75rem)',
                                 marginTop: '0.5rem',
                               }}/>)}
    </Fragment>

  )
}

const mapIcon = status => {
  switch (status) {
    case ANSWERED.NONE:
      return 'icon-circle'
    case ANSWERED.PART:
      return 'icon-dot-circle'
    case ANSWERED.FULL:
      return 'icon-check-circle'
    default:
      return 'icon-warning'
  }
}

const mapIconStyle = status => {
  switch (status) {
    case ANSWERED.NONE:
      return 'ans-status-none'
    case ANSWERED.PART:
      return 'ans-status-part'
    case ANSWERED.FULL:
      return 'ans-status-full'
    default:
      return ''
  }
}
export default ChildInline
